import {
    defaultBillingAccountId,
    preClearBillingAccountId,
    prePendingBillingAccountId,
    preRecurringBillingAccountId,
} from "@/mock-api/data/billingAccountIds.ts";
import type { CustomBillableProduct } from "@warrenio/api-spec/spec.oats.gen";

export const adminCustomProductsExample: CustomBillableProduct[] = [
    {
        uuid: "1e96bf76-a853-4f2e-8a96-fbacb610e0ed",
        description: "PostgreSQL setup",
        start_date: "2020-08-12T08:40:00.000+00:00",
        end_date: "2020-08-12T08:40:00.000+00:00",
        billing_account_id: defaultBillingAccountId,
        user_id: 28,
        price_per_unit: 20.0,
        qty_unit: "pc",
        creator_user_id: -1,
        created_at: "2020-08-12T08:44:24.521+00:00",
        updated_at: "2025-02-14T09:32:43.113+00:00",
    },
    {
        uuid: "b958fbd6-cafe-4188-b6a6-c07a4429aa56",
        description: "WordPress maintenance",
        start_date: "2020-08-12T14:07:00.000+00:00",
        end_date: null,
        billing_account_id: prePendingBillingAccountId,
        user_id: 8,
        price_per_unit: 15.0,
        qty_unit: "pc",
        creator_user_id: 28,
        created_at: "2020-08-13T08:43:40.692+00:00",
        updated_at: "2025-02-14T09:32:43.113+00:00",
    },
    {
        uuid: "6498e300-063c-48e4-b481-98ca7ea8fe62",
        description: "Support PostgreSQL",
        start_date: "2020-08-12T08:45:00.000+00:00",
        end_date: "2020-08-13T22:00:00.000+00:00",
        billing_account_id: defaultBillingAccountId,
        user_id: 28,
        price_per_unit: 10.0,
        qty_unit: "h",
        creator_user_id: -1,
        created_at: "2020-08-12T11:04:18.829+00:00",
        updated_at: "2025-02-14T09:32:43.113+00:00",
    },
    {
        uuid: "8fa26661-d857-4936-b7e5-2e25a84f42e8",
        description: "win, Windows license 371 h in Oct",
        start_date: "2024-12-10T10:30:00.000+00:00",
        end_date: "2024-12-10T10:30:00.000+00:00",
        billing_account_id: preClearBillingAccountId,
        user_id: 136,
        price_per_unit: 5.56,
        qty_unit: "pc",
        creator_user_id: 28,
        created_at: "2024-12-10T13:18:44.471+00:00",
        updated_at: "2025-02-14T09:32:43.113+00:00",
    },
    {
        uuid: "1258caba-2e7e-4139-a0bc-464af1e9e57a",
        description: "win, Windows license 720 h in Nov",
        start_date: "2024-12-10T10:30:00.000+00:00",
        end_date: "2024-12-10T10:30:00.000+00:00",
        billing_account_id: preClearBillingAccountId,
        user_id: 136,
        price_per_unit: 10.78,
        qty_unit: "pc",
        creator_user_id: 28,
        created_at: "2024-12-10T13:18:44.567+00:00",
        updated_at: "2025-02-14T09:32:43.113+00:00",
    },
    {
        uuid: "c1703cd8-86d8-40fe-9809-540a5c7a2765",
        description: "windows, Windows license 371 h in Oct",
        start_date: "2024-12-10T10:30:00.000+00:00",
        end_date: "2024-12-10T10:30:00.000+00:00",
        billing_account_id: preRecurringBillingAccountId,
        user_id: 29,
        price_per_unit: 5.56,
        qty_unit: "pc",
        creator_user_id: 28,
        created_at: "2024-12-10T13:18:44.666+00:00",
        updated_at: "2025-02-14T09:32:43.113+00:00",
    },
    {
        uuid: "8eb73410-aa62-4be2-8579-c36797abe801",
        description: "windows, Windows license 720 h in Nov",
        start_date: "2024-12-10T10:30:00.000+00:00",
        end_date: "2024-12-10T10:30:00.000+00:00",
        billing_account_id: preRecurringBillingAccountId,
        user_id: 29,
        price_per_unit: 10.78,
        qty_unit: "pc",
        creator_user_id: 28,
        created_at: "2024-12-10T13:18:44.758+00:00",
        updated_at: "2025-02-14T09:32:43.113+00:00",
    },
    {
        uuid: "4f80957c-4922-4e1f-a35b-28df90720f46",
        description: "test-product",
        start_date: "2025-02-01T00:30:00.000+00:00",
        end_date: null,
        billing_account_id: defaultBillingAccountId,
        user_id: 9,
        price_per_unit: 11.11,
        qty_unit: "h",
        creator_user_id: 9,
        created_at: "2025-01-31T12:21:00.820+00:00",
        updated_at: "2025-02-14T09:32:43.113+00:00",
    },
];
